import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import ChatPage from '../../pages/whatsapp/ChatPage';
import ResolvePanel from '../../pages/whatsapp/ResolvePanel';
import { saveWhatsappChatMetaData, resetWhatsappChat } from '../../redux/slices/whatsappV2';
import { useDispatch } from '../../redux/store';

// Embedded WhatsApp chat popup body: pre-loads chat metadata then renders ChatPage + ResolvePanel.
// Shared by V1 TaskReminder and V2 dashboard task widget.
const WaPopupChat = ({ lead, thread, phoneNumber, practiceId, taskId, onResolved, onOpenWorkflow }) => {
    const dpatch = useDispatch();
    const [resolveOpen, setResolveOpen] = useState(false);
    const [chatMsgSetter, setChatMsgSetter] = useState(null);

    useEffect(() => {
        if (lead && thread) {
            const name = `${lead.first_name || ''} ${lead.last_name || ''}`.trim();
            dpatch(saveWhatsappChatMetaData({
                leadId: lead.id,
                thread,
                name: name || phoneNumber,
                phoneNumber: phoneNumber?.replace?.(/\+/g, '') || '',
                avatar: null,
                isCloseObject: { isClosed: thread?.is_closed, closedReason: thread?.metadata?.close_reason },
            }));
        }
        return () => dpatch(resetWhatsappChat());
    }, [lead, thread, phoneNumber, dpatch]);

    const contactDetails = {
        name: `${lead?.first_name || ''} ${lead?.last_name || ''}`.trim() || phoneNumber,
        leadDetails: lead,
    };

    return (
        <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', height: '100%' }}>
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
                <ChatPage
                    embedded
                    onToggleDetails={() => {}}
                    detailsOpen={false}
                    onOpenResolve={() => setResolveOpen(prev => !prev)}
                    onSetChatMessage={(setter) => setChatMsgSetter(() => setter)}
                />
            </Box>
            {resolveOpen && (
                <ResolvePanel
                    open={resolveOpen}
                    onClose={() => setResolveOpen(false)}
                    onConfirmClose={(reason) => {
                        setResolveOpen(false);
                        if (onResolved) onResolved(reason);
                    }}
                    contactDetails={contactDetails}
                    practiceId={practiceId}
                    taskId={taskId}
                    onOpenWorkflow={onOpenWorkflow}
                    onShareMessage={(msg) => { if (chatMsgSetter) chatMsgSetter(msg); }}
                />
            )}
        </Box>
    );
};

WaPopupChat.propTypes = {
    lead: PropTypes.object,
    thread: PropTypes.object,
    phoneNumber: PropTypes.string,
    practiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onResolved: PropTypes.func,
    onOpenWorkflow: PropTypes.func,
};

export default WaPopupChat;
